/**
 * created by wang lei
 取消超链接页面
 *
 */
import React, {Component} from 'react';
import hyperlinkCancel from './hyperlinkCancel.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class HyperlinkCancelTool extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            hyperLink:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let hyperLink = this.props.editor.queryCommandValue("link");
        this.setState({hyperLink: hyperLink !== undefined && hyperLink !== null});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let hyperLink = this.props.editor.queryCommandValue("link");
        this.setState({hyperLink: hyperLink !== undefined && hyperLink !== null});

    }

    render() {
        return (
            <span style={{cursor: "pointer" ,opacity:this.state.hyperLink ? "1":"0.3"}} onClick={() => {
                this.props.editor.execCommand('unlink');
            }}>
                <span>
                    <img className={"editor-hyper-link-cancel-tool-btn"} src={hyperlinkCancel}/>
                </span>
                {this.state.hyperLink ? <style>{`
                .editor-hyper-link-cancel-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-hyper-link-cancel-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-hyper-link-cancel-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-hyper-link-cancel-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-hyper-link-cancel-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-hyper-link-cancel-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}